// @flow

import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import { useIntl } from 'gatsby-plugin-intl'
import { applyStylingHoc, type StyleOuterProps, type StyleProps } from '@fcse/tsbob/dist/lib/styling'
import messages from './ReadMore.lang'
import baseStyles from './ReadMore.scss'

type Props = {
  ...StyleProps,
  text: any,
  height: number
}

const ReadMoreAnimate = ({ styles, text, height }: Props) => {
  const { formatMessage } = useIntl()
  const [expanded, toggleLines] = useState(false)
  const [isTogglerNeeded, setToggler] = useState(false)
  let textBlockWrapper = React.createRef()
  let inited = false
  useEffect(() => {
    if (!inited) {
      if (textBlockWrapper.current && textBlockWrapper.current.children[0].offsetHeight > height) {
        setToggler(true)
        inited = true
      }
    }
  }, [inited])
  const toggle = expanded => {
    const target = textBlockWrapper.current
    if (target) {
      if (!expanded) {
        target.style.maxHeight = height + 'px'
      } else {
        target.style.maxHeight = target.children[0].offsetHeight + 'px'
      }
      toggleLines(expanded)
    }
  }
  return (
    <div className={classNames(styles.root, expanded && styles.expanded, isTogglerNeeded && styles.toggable)}>
      <div className={styles.wrapper} style={{ maxHeight: height + 'px' }} ref={textBlockWrapper}>
        <div className={styles.text}>{text}</div>
      </div>
      {isTogglerNeeded && (
        <span className={styles.toggler} onClick={() => toggle(!expanded)}>
          {formatMessage(expanded ? messages.readLess : messages.readMore)}
        </span>
      )}
    </div>
  )
}

export default applyStylingHoc(baseStyles)<$Diff<Props, StyleProps> & StyleOuterProps, Function>(ReadMoreAnimate)
